import { useContext, useEffect, useState } from "react";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const AddTestQuestionPage = () => {


  const { addTest, addTestPost } = useContext(AdminContext);
  const [success, setSuccess] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [question, setQuestion] = useState('');
  const [answers, setAnswers] = useState('')



  const closeSuccess = () => {
    setSuccess(null);
  };

  const isJSON = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  } 

 
  const submitHandler = (e) => {
    e.preventDefault();
    setError(null)
    if(question.length > 6 && answers.length > 8)
    {
      if(!isJSON(answers))
      {
        return setError('Неверный формат ответов')
      }

      addTestPost(answers, question).then(res => {
        if(res.status === 200) {
          setQuestion('')
          setAnswers('')
          setSuccess(res.data)

        }
        else setError(res.response.data.message)
        
      }).then(() => {
        addTest().then((res) => {
          if (res.status === 200) {
           
            setData(res.data);
          }
        });
      })
    }
  }

  const questionHandler = (e) => {
    setQuestion(e.target.value)
  }

  const answersHandler = (e) => {
    setAnswers(e.target.value)
  }

  useEffect(() => {
    document.title = 'Добавить вопрос'
    addTest().then((res) => {
      if (res.status === 200) {
       
        setData(res.data);
      }
    });

  }, [addTest]);

  return (
    <section className="add-test">
      <div className="container">
       
        <ButtonBack shortBtn={true}/>
        <h1 className="add-test__text">Добавление тестовых вопросов</h1>

        <div
          className="add-test__wrapper"
          style={{ position: "relative", minHeight: 650 }}
        >

          {!data ? (
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          ) : (
            <>
              {error && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: 30,
                    color: "crimson",
                    fontSize: 22,
                  }}
                >
                  {error}
                </p>
              )}

              <form className="add-test__form" onSubmit={submitHandler}>
                <p style={{ marginTop: 15, fontSize: 18 }}>
                  Текущая категория:
                  <b style={{ color: "rgb(18, 82, 202)" }}>
                    {data.category.category}
                  </b>
                </p>
                <p style={{ marginTop: 15, fontSize: 18 }}>
                  Кол-во тестов в текущей категории:
                  <b style={{ color: "rgb(18, 82, 202)" }}>
                    {data.count_tests}
                  </b>
                </p>
                <div className="add-test__item">
                  <label htmlFor="question">Введите вопрос: </label>
                  <textarea
                    type="text"
                    id="question"
                    name="question"
                    className="add-test__input "
                    placeholder="Вопрос"
                    autoComplete="off"
                    value={question}
                    onInput={questionHandler}
                    required
                  ></textarea>
                </div>

                <div className="add-test__item">
                  <label htmlFor="answers">
                    Введите ответы в JSON формате:
                  </label>
                  <textarea
                    type="text"
                    id="answers"
                    name="answers"
                    value={answers}
                    className="add-test__input "
                    placeholder="Ответы"
                    style={{ height: 200, fontSize: 16 }}
                    autoComplete="off"
                    onInput={answersHandler}
                    required
                  ></textarea>
                </div>

                <button className="add-test__wrapper__link">Добавить</button>
              </form>
            </>
          )}
        </div>
      </div>
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </section>
  );
};

export default AddTestQuestionPage;
